/* User API */
export default ($http) => ({
  importUsersCsvFile(payload) {
    return $http.post('import-users', { body: payload, headers: { 'Content-Type': 'multipart/form-data' } })
  },
  importUsersValidate(payload) {
    return $http.post('import-users/validate', { body: payload })
  },
  importUsersProcess(payload) {
    return $http.post('import-users/process', { body: payload, timeout: 90000 })
  },
  getUsers(query) {
    return $http.get('users', { query })
  },
  getUser(userId) {
    return $http.get(`users/${userId}`)
  },
  createUser(payload) {
    return $http.post('users', { body: payload })
  },
  updateUser(userId, payload) {
    return $http.put(`users/${userId}`, { body: payload })
  },
  deactivateUserById(userId, payload = {}) {
    return $http.put(`users/${userId}/deactivate`, { body: payload })
  },
  deactivateUsers(payload) {
    return $http.put('users/deactivate', { body: payload })
  },
  getUserCoursesAndLessons(id) {
    return $http.get(`users/${id}/courses-and-lessons`)
  },
  getUsersForReassignment(query) {
    return $http.get('users-for-reassignment', { query })
  },
  activateUser(id) {
    console.log('activateUser', id)
  },
  resendInvitationEmail(payload) {
    return $http.put('users/resend-invitation-email', { body: payload })
  },
  resetUserPassword(id) {
    return $http.put(`users/${id}/reset-password`)
  },
  getDefaultPassword() {
    return $http.get('default-site-password')
  },
  updateDefaultView(payload) {
    return $http.put('user-settings', { body: payload })
  },
  fetchUserSecurityConnection() {
    return $http.get('user-is-inside-firewall-or-connected-to-vpn')
  },
  updatePassword(payload) {
    return $http.post('update-password', { body: payload })
  },
  getEmails() {
    return $http.get('user/email-addresses')
  },
  addEmail(payload) {
    return $http.post('user/email-address', { body: payload })
  },
  confirmEmailAddress(payload) {
    return $http.post('user/confirm-email-address', { body: payload })
  },
  deleteEmail(payload) {
    return $http.delete('user/email-address', { body: payload })
  },
  resendConfirmEmail(payload) {
    return $http.post('user/resend-email-verification', { body: payload })
  },
  getEmailNotificationSettings() {
    return $http.get('user/email-notification-settings')
  },
  updateEmailNotificationSettings(payload) {
    return $http.put('user/email-notification-settings', { body: payload })
  },
  getNotificationsEmail() {
    return $http.get('user/notification-email-address')
  },
  updateNotificationsEmail(payload) {
    return $http.put('user/notification-email-address', { body: payload })
  }
})
